export default "__VITE_ASSET__5f0df7ef__"